import { paymentConfirmationStore } from '@/stores/PaymentConfirmationStore';

type PaymentNavigationMode = 'assign' | 'replace';

export function navigateWithPaymentOverlay(
  url: string,
  mode: PaymentNavigationMode = 'assign',
): void {
  paymentConfirmationStore.startNavigation();

  try {
    if (mode === 'replace') {
      window.location.replace(url);
      return;
    }

    window.location.assign(url);
  }
  catch (error) {
    paymentConfirmationStore.stop();
    throw error;
  }
}
